module.exports = global["$"] = require("-!/builds/fe/kefu-webim/node_modules/i18next-loader/index.js?{\"quotes\":\"\\\"\"}!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 14
// module chunks = 0